import styled from 'styled-components';
import MuiCard from '@mui/material/Card';
import Typography from '@mui/material/Typography';

export const Card = styled(MuiCard)`
  &.MuiPaper-root {
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    overflow: unset;

    .MuiCardContent-root {
      padding: 0;
    }

    &.small-padding {
      padding: 10px;
    }

    &.no-padding {
      padding: 0;
    }
  }

  .card-main-content {
    margin-top: 16px;

    &.mt-0 {
      margin-top: 0;
    }
  }
  .card-notification {
    height: calc(100% - 50px);
  }
`;

export const CardTitle = styled(Typography)`
  &.MuiTypography-root {
    &,
    .card-title {
      font-size: 16px;
      font-weight: 600;
      color: ${(props) => props.theme.card.color};
    }
  }
`;
